export function showStatusBadge(container, text, tone = "disabled") {
  if (!container) return

  let badge = container.querySelector(".status-badge")
  if (!badge) {
    badge = document.createElement("span")
    badge.classList.add("status-badge")
    container.replaceChildren(badge)
  }

  badge.classList.remove("status-enabled", "status-disabled", "status-error")
  badge.classList.add(`status-${tone}`)
  badge.textContent = text
}
